import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text, Icon } from '@components'
import { Theme } from '@theme'

type Network = 'instagram' | 'facebook' | 'twitter' | 'linkedin'

interface NetworkSelectorProps {
  selectedNetwork: Network | null
  onSelect: (network: Network) => void
}

const networks: { id: Network; label: string }[] = [
  { id: 'instagram', label: 'Instagram' },
  { id: 'facebook', label: 'Facebook' },
  { id: 'twitter', label: 'Twitter/X' },
  { id: 'linkedin', label: 'LinkedIn' },
]

export const NetworkSelector = ({ selectedNetwork, onSelect }: NetworkSelectorProps) => {
  const theme = useTheme()
  const styles = getStyles(theme)

  return (
    <View style={styles.container}>
      {networks.map((network) => {
        const isSelected = selectedNetwork === network.id
        return (
          <TouchableOpacity
            key={network.id}
            style={[styles.networkButton, isSelected && styles.networkButtonSelected]}
            onPress={() => onSelect(network.id)}
          >
            <Text
              type="body"
              color={isSelected ? theme.colors.white : theme.colors.primary}
            >
              {network.label}
            </Text>
          </TouchableOpacity>
        )
      })}
    </View>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing.sm,
      justifyContent: 'center',
    },
    networkButton: {
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.lg,
      borderRadius: theme.spacing.xxxl,
      borderWidth: 1,
      borderColor: theme.colors.primary,
    },
    networkButtonSelected: {
      backgroundColor: theme.colors.primary,
    },
  })
